var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PCNavbar',{attrs:{"selectIndex":"1"}}),_c('MobileNavBar',{attrs:{"currentActive":0}}),_c('CarouselHome'),_c('Center'),_c('CoreCompetence'),_c('Run'),_c('TodoShow'),_c('CallMe'),_c('MobileCallme')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }